import { mapActions } from 'vuex'
// import reduceWithSeparator from '@/helpers/reduce-with-separator'

console.log(this.summary)

export default {
  ...mapActions(['loadProfessional']),
  // afterPrepareShow () {
  //   // this.speciality = reduceWithSeparator(this.specialities, 'name')
  // },
  sortableIdentification () {
    this.sortableIdentificationIsActive = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/identification/resources/methods.js